import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { setSeparateStay } from '../../redux/currentSearch/actions';
import { withPageContext, DateUtils, DynpackRoomUtils } from '../../utils';
import { getSegments, getSeparateStay, getSeparateStayErrorSelector } from '../../redux/currentSearch/selectors';

export const SeparateStayDate = ({ children, index, segments, separateStay, setSeparateStay, separateStayError }) => {
    const segmentDep = DateUtils.stringToDate(segments[0].date);
    const segmentRet = DateUtils.stringToDate(segments[1].date);
    const depDateSepStay = DateUtils.stringToDate(DynpackRoomUtils.getSeparateStayValidDate(DateUtils.stringToDate(separateStay.checkInDate),
        segmentDep, -1));
    const retDateSepStay = DateUtils.stringToDate(DynpackRoomUtils.getSeparateStayValidDate(DateUtils.stringToDate(separateStay.checkOutDate),
        segmentRet, 1));

    const dates = [depDateSepStay, retDateSepStay];
    const minDate = index === 0 ? segmentDep : DateUtils.add(depDateSepStay, 1);
    const maxDate = index === 0 ? DateUtils.add(retDateSepStay, -1) : segmentRet;
    const value = index === 0 ? depDateSepStay : retDateSepStay;
    const setValue = (date) => {
        if (index === 0) {
            setSeparateStay({
                ...separateStay,
                checkInDate: date,
            });
        } else {
            setSeparateStay({
                ...separateStay,
                checkOutDate: date,
            });
        }
    };
    return children({ error: separateStayError, dates, minDate, maxDate, setValue, value });
};

SeparateStayDate.propTypes = {
    children: PropTypes.func.isRequired,
};

const mapStateToPropsSelector = createStructuredSelector({
    segments: getSegments,
    separateStay: getSeparateStay,
    separateStayError: getSeparateStayErrorSelector,
});

const ConnectedSeparateStayDate = connect(mapStateToPropsSelector, {
    setSeparateStay,
})(withPageContext(SeparateStayDate));

export { ConnectedSeparateStayDate };
